import { getArrayDims, getNiceDate, objectsKeysAsCol, sortById } from '@iotv/datamodel-core';
/**
 * Returns a table with headers as keys of `k2` as headers, `k1` as left column
 * `k1` is omitted if `includeKeyColumn` is `false`
 *
 * Previously, geneated a horizontal set of similar `k2` keyed objects, with `k1` as row headers
 * @param mapOfMaps
 * @param includeKeyColumn - whether to include `mapOfMaps.k1` as row headers
 */
const getMatrixOfObjectProperties = (mapOfMaps, includeKeyColumn = true) => {
    const firstColumn = Object.keys(mapOfMaps);
    const intermediate = objectsKeysAsCol(Object.values(mapOfMaps));
    const headers = intermediate[0];
    const body = intermediate.slice(1);
    const rows = firstColumn.map((metricKey, i) => [metricKey, ...body[i]]);
    if (includeKeyColumn) {
        headers.unshift('');
    }
    else {
        rows.forEach((row) => row.shift());
    }
    // console.log('cmv table', rows)
    return [headers, ...rows];
};
export const spreadsheetize = (coverageReport) => {
    const dateFormat = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
    const ssArr = [];
    const insert = (targetTable, subTable, row, col) => {
        subTable.forEach((subRow, i) => {
            if (!targetTable[row + i])
                targetTable[row + i] = [];
            subRow.forEach((val, j) => {
                targetTable[row + i][col + j] = val;
            });
        });
    };
    const insertString = (targetTable, s, row, col) => insert(targetTable, [[s]], row, col);
    const { GeoObject, Networks, created, timePeriod: { fromDateMs, toDateMs }, } = coverageReport;
    insertString(ssArr, GeoObject.name ?? GeoObject.sk, 2, 0);
    insert(ssArr, [[getNiceDate(fromDateMs, dateFormat), getNiceDate(toDateMs, dateFormat)]], 2, 2);
    insertString(ssArr, getNiceDate(new Date(created).valueOf(), dateFormat), 2, 4);
    const addNetworkTable = ({ GatewayStats, Gateways }, row, col) => {
        let currentRow = row;
        let currentCol = col;
        Gateways.sort(sortById).forEach((gw, i) => {
            const stats = GatewayStats[gw.id];
            if (stats) {
                insertString(ssArr, gw.name ?? gw.eui ?? gw.sk, currentRow, 2);
                currentCol = 3;
                const includeKeyColumn = i === 0;
                const { power, rssi, sf, snr, esp, dropped } = stats;
                [power, rssi, sf, snr, esp].forEach((cmv) => {
                    delete cmv?.lastTimeStamp;
                    delete cmv?.firstTimestamp;
                });
                const statsForAtts = getMatrixOfObjectProperties({ power, rssi, sf, snr, esp, dropped: { dropped: 0 } });
                const dims = getArrayDims(statsForAtts);
                insert(ssArr, statsForAtts, currentRow, currentCol);
                currentCol += dims.cols;
            }
            currentRow = getArrayDims(ssArr).rows + 1;
        });
    };
    Object.entries(Networks).forEach(([nwKey, nwMetrics]) => {
        let currentRow = getArrayDims(ssArr).rows;
        insertString(ssArr, nwKey, currentRow, 0);
        currentRow++;
        addNetworkTable(nwMetrics, currentRow, 1);
    });
    return ssArr;
};
